import { CollaboratorsQuery } from '~/generated/graphql';

/** Collaborator with Company */
export type ToCollaborator = CollaboratorsQuery['collaborators'][number] & {
  company?: ProjectCompany;
};

export type Selected = Record<string, boolean>;

export enum UsersSortKey {
  COMPANY = 'company.company.name',
  NAME = 'user.name',
  ROLE = 'role.name',
}

export type UsersSortBy = {
  sortDirection: SortDirection;
  sortKey: UsersSortKey;
};

export type BoolMap = Record<UUID, boolean>;

export type TooltipMap = Record<UUID, string>;
